import { AlphaOIcon } from './AlphaOIcon';

/**
 * author: GreenTurtwig
 * id 67F8B291-3AA9-4C70-AEAB-0150A40909FB
 * name alpha-o
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterOIcon = AlphaOIcon;
export default LetterOIcon